module.exports = __webpack_public_path__ + "img/huxiq.0452f954.jpg";